import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { storageNames } from '@/shared/constants/storage-names'
import pipes from '@/shared/lib/helpers/pipes'
import { Dto } from '../types/hypotheses-filter'

export interface StoreProps {
  values: Partial<Dto> | undefined
  stringValues: Record<keyof Dto, string> | undefined
  setValues: ({ values }: Pick<StoreProps, 'values'>) => void
  clearValues: () => void
}

const useStore = create<StoreProps>()(
  persist(
    (set, get) => ({
      values: undefined,
      stringValues: undefined,
      setValues: ({ values }) => {
        if (values) {
          const stringValues = pipes.objectsValueToString<keyof Dto>(values, {
            objectFieldName: 'id',
          })
          set({ stringValues })
        }

        return set({ values })
      },
      clearValues: () => set({ values: undefined, stringValues: undefined }),
    }),
    {
      name: storageNames.zustand_hypotheses_filter,
    },
  ),
)
export default useStore
